import { Container, Row, Col, Button } from 'react-bootstrap';
import './AboutUs.css';
import { useAboutUsStore } from '../../../../store/useAboutUsStore';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../Loader';

const AboutBanner = () => {
    const { getBanner, banner } = useAboutUsStore()
    const [loading, setLoading] = useState(false)

    const fetchBannerData = async () => {
        setLoading(true)
        await getBanner()
        setLoading(false)
    }

    useEffect(() => {
        if (!banner) {
            fetchBannerData()
        }
    }, [banner, getBanner])
    return (
        <div>
            <Loader loading={loading}>
                <div className="about-banner-section" style={{
                    "--aboutUs-bg": banner?.image ? `url(${banner.image})` : ""
                }}>
                    <div className="about-banner-overlay" />
                    <Container className="theme-container">
                        <Row className="align-items-center">
                            <Col md={8} lg={6}>
                                <div className='about-banner-content'>
                                    <p className="section-subtitle mb-xl-2 mb-1">{banner?.subTitle}</p>
                                    <h2 className="section-sub-title mb-xl-3 mb-2">
                                        {banner?.title}
                                    </h2>
                                    <p className="about-banner-description fontsize-20">
                                        {banner?.description}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Loader>
        </div>
    );
};

export default AboutBanner;
